<template>
  <div>
    <!-- JKKP 6 Details -->
    <div class="row" style="padding: 1%;">
      <div class="col-lg-6" style=" border-bottom: solid red;">
        <h4 class="info-text">BAHAGIAN A - Maklumat Pemberitahu</h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <div class="row">
              <div class="col-md-6">
                <base-input label="Nama" v-model="notifier.name"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Jawatan" v-model="notifier.designation"></base-input>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-lg-12">
                    <base-input label="Nama Organisasi" v-model="notifier.org"></base-input>
                    <base-input label="No Telefon" v-model="notifier.phoneno"></base-input>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <base-input label="Alamat Organisasi">
                  <textarea class="address"></textarea>
                </base-input>
              </div>
              <div class="col-md-3">
                <base-input disabled label="Kod Industri" v-model="kodIndustri" style="color:white"></base-input>
              </div>
              <div class="col-md-9">
                <base-input disabled label="Sektor Industri" v-model="sekIndustri"></base-input>
              </div>
              <div class="col-md-6">
                <base-input disabled label="No. ROC" v-model="noROC" style="color:white"></base-input>
              </div>
              <div class="col-md-6">
                <base-input disabled label="No. Pend. JKKP" v-model="noJKKP"></base-input>
              </div>
              <div class="col-lg-12">
                <base-input label="Orang yang boleh dihubungi">
                  <textarea class="address"></textarea>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-lg-6"
        style="border-left: solid red; border-bottom: solid red; padding-bottom: 1%"
      >
        <h4 class="info-text">BAHAGIAN B - Orang Yang Terlibat</h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <div class="row">
              <div class="col-md-6">
                <base-input label="Nama"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Tarikh Lahir"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="No K/P"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="No Pekerja"></base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Warganegara"></base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Jantina"></base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Pekerjaan"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Tempat Kejadian">
                  <textarea class="address"></textarea>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Alamat Organisasi">
                  <textarea class="address"></textarea>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Tarikh dan Masa Kejadian"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Tarkih Mula Lapor kepada JKKP"></base-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <h4 class="info-text">BAHAGIAN C - Huraian kemalangan atau kejadian berbahaya</h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-12">
                <textarea></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- JKKP 7 Details -->
    <div class="row" style="padding: 1%;">
      <div class="col-lg-6" style="border-bottom: solid red">
        <h4 class="info-text">BAHAGIAN A1 - Pemberitahuan - Peraturan 7 (1)</h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <div class="row">
              <div class="col-md-6">
                <base-input label="Nama"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Jawatan"></base-input>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-lg-12">
                    <base-input label="Nama Organisasi"></base-input>
                    <base-input label="No Telefon"></base-input>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <base-input label="Alamat Organisasi">
                  <textarea class="address"></textarea>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="No. ROC"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="JKKP"></base-input>
              </div>
              <div class="col-lg-12">
                <base-input label="Orang yang boleh dihubungi">
                  <textarea class="address"></textarea>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6" style="border-left: solid red; border-bottom: solid red">
        <h4
          class="info-text"
        >BAHAGIAN A2 - Pemberitahuan - Peraturan 7 (2) Pengamal Perubatan Berdaftar</h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <div class="row">
              <div class="col-md-6">
                <base-input label="Nama"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Jawatan"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="No Telefon"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Alamat Klinik / Hospital">
                  <textarea class="address"></textarea>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6" style="border-bottom: solid red;">
        <h4 class="info-text">BAHAGIAN B - Orang Yang Terlibat</h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <div class="row">
              <div class="col-md-6">
                <base-input label="Nama"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Tarikh Lahir"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="No K/P atau No. Passport"></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="No Pekerja"></base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Warganegara"></base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Jantina"></base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Pekerjaan"></base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Nama Organisasi"></base-input>
              </div>
              <div class="col-md-8"></div>
              <div class="col-md-6">
                <base-input label="Alamat Organisasi">
                  <textarea class="address"></textarea>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Lokasi Kejadian">
                  <textarea class="address"></textarea>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6" style="border-left: solid red; border-bottom: solid red">
        <h4 class="info-text">BAHAGIAN C - Keracunan Pekerjaan / Penyakit</h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <base-input label="Diagnosis / Diagnosis Sementara"></base-input>
            <base-input label="Select Year">
              <el-date-picker v-model="value1" type="date"></el-date-picker>
            </base-input>
            <base-input label="Nama Doktor"></base-input>
            <base-input label="Alamat Doktor">
              <textarea class="address"></textarea>
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <h4 class="info-text">BAHAGIAN D</h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <textarea
              class="huraian"
              placeholder="Huraian pekerjaan yang membawa kepada keracunan pekerjaan / penyakit pekerjaan (Sila huraikan sebarang kerja
yang dibuat oleh orang yang terlibat yang mungkin telah membawa kepada penyakit. Jika mungkin disebabkan oleh pendedahan kepada sebarang agen semasa kerja, contoh kimia yang spesifik - sila nyatakan agen berkenaan). "
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker
  },
  data() {
    return {
      noROC: "938781-W",
      noJKKP: "SL/18/23/118751",
      kodIndustri: "74931",
      sekIndustri: "Industrial Waste Collection & Disposal Service",
      value1: "",
      tableSiteRoute: [
        {
          siteRoute: "Route A"
        },
        {
          siteRoute: "Route B"
        }
      ],
      selects: {
        condition: [
          { value: "operational", label: "Operational" },
          { value: "Not operational", label: "Not Operational" }
        ]
      },
      model: {
        file: null
      }
    };
  },
  mounted(){
    this.$root.$on('updateinvestigation', row => {
      console.log(row)
    })
  },
  methods: {
    onFileChange(file) {
      this.file = file;
    },
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    }
  }
};
</script>
<style  lang="scss">
// .form-control[disabled] {
//   color: white;
// }
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  color: grey;
  font-weight: 300;
}
textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
}
.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
}
</style>
